import React from 'react';

import styles from './HeaderSpiner.module.scss';

const HeaderSpiner = () => (
  <div className={styles.spin_wrapper}>
    <div className={styles.spinner} />
  </div>
);

export default HeaderSpiner;
